import { Component } from "excalibur";

export class HarvestRateIncreaseComponent extends Component {}
